import rootStore from "@/app/store";
import { handbookMap, Handbook } from "./handbookMap";
import { Dispatch } from "redux";

type LoadHandbooksOptions = {
  handbooks: Handbook[] | "all";
  arguments?: any[];
  dispatch?: Dispatch;
};

export async function loadHandbooks({
  handbooks,
  arguments: args = [],
}: LoadHandbooksOptions): Promise<Record<Handbook, any>> {
  const toLoad: Handbook[] =
    handbooks === "all" ? (Object.keys(handbookMap) as Handbook[]) : handbooks;

  const promises = toLoad.map((handbook, index) => {
    const apiCall = handbookMap[handbook].apiCall;
    return Array.isArray(args[index]) ? apiCall(args[index]) : apiCall(args[0]);
  });

  const results = await Promise.allSettled(promises);

  const data: Partial<Record<Handbook, any>> = {};

  results.forEach((result, index) => {
    const handbook = toLoad[index];
    if (result.status === "fulfilled") {
      data[handbook] = result.value.data ? result.value.data : result.value;
      rootStore.dispatch(handbookMap[handbook].action(data[handbook]));
    } else {
      console.error(`Failed to load handbook "${handbook}":`, result.reason);
    }
  });

  return data as Record<Handbook, any>;
}
